import axiosInstance from '../../../config/axiosInstance';
const OpportunityDocumentService = {
    async GetAllOpportunityDocument(redirectCallback, OpportunityID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Oppurtunity/GetAllOpportunityDocument?OpportunityID=${OpportunityID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteOpportunityDocument(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Oppurtunity/DeleteOpportunityDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default OpportunityDocumentService;